import { defineAsyncComponent } from "vue";

export default {
    sectionContainer: defineAsyncComponent(() => import("./SectionContainer.vue")),
    webButton: defineAsyncComponent(() => import("./WebButton.vue")),
    heroContent: defineAsyncComponent(() => import("./HeroContent.vue")),
    card: defineAsyncComponent(() => import("./Card.vue")),
    tokens: {
        // Falls back gracefully to Georgia/serif if Playfair Display isn't
        // loaded as a webfont (only Inter is linked in index.html today).
        "--theme-font-family": "'Playfair Display', Georgia, serif",
    },
};
